/* eslint-disable */
import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      flexGrow: 1,
      maxWidth: 324,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(4),
      paddingTop: theme.spacing(2),
      backgroundColor: theme.palette.common.white,
      marginRight: theme.spacing(1),
    },
  })
);
